<template>
  <div class="Notification-fallback">
    <div class="Notification-fallbackGraphic">
      <svg>
        <use xlink:href="#Ryi" />
      </svg>
    </div>
    <h3>You have no upcoming job notifications</h3>
    <p>Jobs you register your interest in will appear here.</p>
    <img
      :src="image"
      alt="no register your interest"
    >
    <p>Click on the clipboard icon next to a job to register your interest. You will be notified as soon as applications open.</p>
  </div>
</template>
<script>
import RYISearchHint from '../images/ryi-search-hint.png';

export default {
  data() {
    return {
      image: RYISearchHint,
    };
  },
};
</script>
